import styled, { css } from 'styled-components';

export const List = styled.ul`
  overflow: scroll;
  margin: 0;
  height: calc(100% - 50px);
`;

export const Container = styled.div`
  height: 100%;
  overflow: hidden;
`;

export const ExtendedSidebarHeader = styled.div`
  font-size: 16px;
  line-height: 19px;
  color: gray;
  display: flex;
  flex-direction: row;
  padding: 16px;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.mediumGrayText};
`;

export const CloseButton = styled.span`
  display: block;
  position: relative;
  padding-left: 10px;
  transform: rotate(180deg);
`;

export const Title = styled.div`
  padding: 0;
  flex: 1;
`;

export const ItemContainer = styled.li`
  display: flex;
  width: 100%;
  cursor: pointer;
  ${({ theme }) => css`
    &:hover {
      background-color: ${theme.colors.viewer.sidebar.hoverItemBackground};
    }
  `}
`;

export const ItemCount = styled.span`
  ${({ theme }) => css`
    ${theme.mixins.font('medium', 12)}
    color: ${theme.colors.white};
  `}
`;

export const ItemDetails = styled.div`
  line-height: 1.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${({ theme }) => css`
    height: ${theme.utils.pxToRem(40)}rem;
    color: ${theme.colors.viewer.sidebar.headerText};
    margin-left: ${theme.utils.pxToRem(8)}rem;
  `}
`;

export const ItemName = styled.div`
  ${({ theme }) => css`
    ${theme.mixins.font('book', 12)}

    ${ItemContainer}:hover & {
      color: ${theme.colors.defaultActionBlue};
    }
  `}
`;

export const ItemArea = styled.div`
  ${({ theme }) => theme.mixins.font('medium', 12)}
`;
